import React, { useState, useEffect, useRef } from 'react';
import clienteAxios from "../../axios";
import Dasboard from "../dasboard/dashboard";
import ModalConfirm from '../ModalConfirm';
import { useNavigate } from "react-router-dom";
import InventarioCocina from './InventarioCocina';
import PersonalCocina from './PersonalCocina';
import PedidosCocina from './PedidosCocina';

const Cocinas = () => {    
    const [cocinas, setCocinas] = useState([]);
    const [nuevaCocina, setNuevaCocina] = useState({ nombre: "", ubicacion: "", restaurante_id: "" });
    const [editandoCocinaId, setEditandoCocinaId] = useState(null);
    const [cocinaEditada, setCocinaEditada] = useState({ nombre: "", ubicacion: "", restaurante_id: "" });
    const [cocinaSeleccionada, setCocinaSeleccionada] = useState(null);
    const [mensajeExito, setMensajeExito] = useState(false);
    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const [cocinaAEliminar, setCocinaAEliminar] = useState(null);
    const [mostrarFormulario, setMostrarFormulario] = useState(false); // Para mostrar u ocultar el formulario de agregar cocina
    const [mostrarPersonalCocina, setMostrarPersonalCocina] = useState(false); // Nuevo estado
    const [componenteActivo, setComponenteActivo] = useState(null); // Para controlar qué componente está activo
    const [botonActivo, setBotonActivo] = useState(null); // Estado para almacenar el botón activo
    const [busqueda, setBusqueda] = useState(""); // Nuevo estado para la barra de búsqueda
    const formularioRef = useRef(null);
    const navigate = useNavigate(); // Para redirigir en logout
    const inputRef = useRef(null);

  
    useEffect(() => {
        obtenerCocinas();
    }, []);


    // Función para cambiar el componente visible
    const cambiarComponenteActivo = (componente) => {
        if (componenteActivo === componente) {
            setComponenteActivo(null); // Cierra si ya está abierto
        } else {
            setComponenteActivo(componente); // Abre el nuevo componente
        }
    };

    // Obtener lista de cocinas
    const obtenerCocinas = async () => {
        try {
            const response = await clienteAxios.post("/api/sp", {
                sp: "tools",
                op: "Listar",
                modulo: "cocinas"
            });
            setCocinas(response.data.data[0]);
        } catch (error) {
            console.log(error);
        }
    };


    // Función para manejar el cambio en la barra de búsqueda
    const handleBusqueda = (e) => {
        setBusqueda(e.target.value.toLowerCase());
    };

    // Filtrar las transacciones en función del término de búsqueda
    const cocinasFiltradas = cocinas.filter((cocina) => {
        return (
            cocina.nombre.toString().toLowerCase().includes(busqueda) ||
            cocina.ubicacion.toString().toLowerCase().includes(busqueda) ||
            cocina.id.toString().toLowerCase().includes(busqueda)
        );
    });



    // Función para agregar una nueva cocina
    const handleAgregarCocina = async (e) => {
        e.preventDefault();
        try {
            await clienteAxios.post("/api/sp", {
                sp: "tools",
                op: "Agregar",
                modulo: "cocinas",
                nombre: nuevaCocina.nombre,
                ubicacion: nuevaCocina.ubicacion,
                restaurante_id: nuevaCocina.restaurante_id
            });

            setNuevaCocina({ nombre: "", ubicacion: "", restaurante_id: "" });
            obtenerCocinas();
        } catch (error) {
            console.log(error);
        }
    };

    // Función para editar una cocina existente
    const editarCocina = (idCocina, cocinaActual) => {
        setEditandoCocinaId(idCocina);
        setCocinaEditada(cocinaActual);
        setCocinaSeleccionada(idCocina);
        setTimeout(() => {
            if (inputRef.current) {
                inputRef.current.focus();
                inputRef.current.setSelectionRange(0, 0);
            }
        }, 0);
    };

    // Función para guardar los cambios de la cocina editada
    const guardarCocinaEditada = async (idCocina) => {
        try {
            await clienteAxios.post("/api/sp", {
                sp: "tools",
                op: "Actualizar",
                modulo: "cocinas",
                id: idCocina,
                nombre: cocinaEditada.nombre,
                ubicacion: cocinaEditada.ubicacion,
                restaurante_id: cocinaEditada.restaurante_id
            });

            setEditandoCocinaId(null);
            setCocinaSeleccionada(null);
            obtenerCocinas();
        } catch (error) {
            console.log(error);
        }
    };

    // Función para mostrar modal de confirmación al eliminar cocina
    const confirmarEliminarCocina = (idCocina) => {
        setCocinaAEliminar(idCocina);
        setShowConfirmModal(true);
    };

    // Función para eliminar una cocina
    const eliminarCocina = async () => {
        try {
            await clienteAxios.post("/api/sp", {
                sp: "tools",
                op: "Eliminiar",
                modulo: "cocinas",
                id: cocinaAEliminar
            });

            setShowConfirmModal(false);
            obtenerCocinas(); // Actualizar la lista de cocinas después de eliminar
        } catch (error) {
            console.log(error);
        }
    };

    // Cancelar la edición o la selección de una cocina
    const cancelarSeleccion = () => {
        setCocinaSeleccionada(null);
        setEditandoCocinaId(null);
    };

    // Seleccionar una cocina para mostrar su inventario
    const seleccionarCocina = (cocina) => {
        setCocinaSeleccionada(cocina);
    };

    const manejarClickBoton = (botonId) => {
        setBotonActivo(botonId); // Actualizar el botón activo
    };

    const handleMostrarFormulario = () => {
        setMostrarFormulario(true);
        setTimeout(() => {
            formularioRef.current.scrollIntoView({ behavior: 'smooth' });
        }, 100); // Un pequeño retraso para asegurar que el formulario esté visible antes de hacer scroll
    };


    return (
        <>
            <Dasboard  />
            <main className="-mt-32">
                <div className="mx-auto max-w-7xl px-4 pb-12 sm:px-6 lg:px-8">
                    <div className="rounded-lg bg-white px-5 py-6 shadow sm:px-6 max-w-full overflow-hidden">
                        <h2 className="text-2xl font-bold mb-6 mt-4">Cocinas</h2>

                        {/* Barra de búsqueda */}
                        <input
                            type="text"
                            placeholder="Buscar transacción..."
                            value={busqueda}
                            onChange={handleBusqueda}
                            className="border rounded-lg p-2 mb-4 w-full"
                        />
                        <ul>
                            {cocinasFiltradas.map((cocina) => (
                                <li key={cocina.id} className="border p-4 rounded-lg mb-4 cursor-pointer"
                                    onClick={() => setCocinaSeleccionada(cocina.id)}>
                                    <div>
                                        {editandoCocinaId === cocina.id ? (
                                            <div className="flex flex-col">
                                                <h3 className=" font-semibold">Nombre:</h3>
                                                <input
                                                    type="text"
                                                    ref={inputRef}
                                                    value={cocinaEditada.nombre}
                                                    onChange={(e) => setCocinaEditada({ ...cocinaEditada, nombre: e.target.value })}
                                                    className="border rounded-lg p-2 mb-2"
                                                    maxLength={50}
                                                />

                                                <h3 className=" font-semibold">Ubicación:</h3>
                                                <input
                                                    type="text"
                                                    value={cocinaEditada.ubicacion}
                                                    onChange={(e) => setCocinaEditada({ ...cocinaEditada, ubicacion: e.target.value })}
                                                    className="border rounded-lg p-2 mb-2"
                                                    maxLength={50}
                                                />

                                                <h3 className=" font-semibold">Restaurante ID:</h3>
                                                <input
                                                    type="number"
                                                    value={cocinaEditada.restaurante_id}
                                                    onChange={(e) => setCocinaEditada({ ...cocinaEditada, restaurante_id: e.target.value })}
                                                    className="border rounded-lg p-2 mb-2"
                                                    maxLength={10}
                                                />

                                                <div className="flex">
                                                    <button onClick={() => guardarCocinaEditada(cocina.id)}
                                                        className="bg-green-500 text-white rounded px-2 py-1 mr-2 w-40">Guardar</button>
                                                    <button onClick={() => setEditandoCocinaId(null)}
                                                        className="bg-gray-500 text-white rounded px-2 py-1 w-40">Cancelar</button>
                                                </div>
                                            </div>
                                        ) : (
                                            <div className="flex flex-col">
                                                <span><strong>Nombre:</strong> {cocina.nombre}</span>
                                                <span><strong>Ubicación:</strong> {cocina.ubicacion}</span>
                                                <span><strong>Restaurante ID:</strong> {cocina.restaurante_id}</span>
                                            </div>
                                        )}
                                    </div>

                                    {cocinaSeleccionada === cocina.id && !editandoCocinaId && (
                                        <>
                                            <div className="relative">
                                                <div className="flex items-center ">
                                                    <button
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            editarCocina(cocina.id, cocina);
                                                        }}
                                                        className="bg-gray-500 text-white rounded px-2 py-1 mr-2 hover:bg-gray-400"
                                                    >
                                                        Editar Cocina
                                                    </button>

                                                    <button
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            confirmarEliminarCocina(cocina.id);
                                                        }}
                                                        className="bg-red-600 text-white rounded px-2 py-1 mr-2 hover:bg-red-500"
                                                    >
                                                        Borrar Cocina
                                                    </button>
                                                </div>
                                                {/* Botón "X" en la esquina superior derecha para cancelar */}
                                                <button
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        cancelarSeleccion(); // Acción para cancelar la selección
                                                    }}
                                                    className="absolute top-[-5.5rem] right-0 text-gray-500 hover:text-red-500 p-2 text-3xl"
                                                >
                                                    &times;
                                                </button>
                                            </div>

                                            <div className="mt-12">
                                                {/* Botón para alternar InventarioCocina */}
                                                <button
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        cambiarComponenteActivo('inventario');
                                                    }}
                                                    className={`rounded px-4 py-2 mt-2 text-white ${componenteActivo === 'inventario' ? 'bg-green-500' : 'bg-gray-500'
                                                        }`}
                                                >
                                                    {componenteActivo === 'inventario' ? "Inventario" : "Inventario"}
                                                </button>

                                                {/* Botón para alternar PersonalCocina */}
                                                <button
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        cambiarComponenteActivo('personal');
                                                    }}
                                                    className={`rounded px-4 py-2 mt-2 ml-2 text-white ${componenteActivo === 'personal' ? 'bg-green-500' : 'bg-gray-500'
                                                        }`}
                                                >
                                                    {componenteActivo === 'personal' ? "Personal" : "Personal"}
                                                </button>

                                                {/* Botón para alternar PedidosCocina */}
                                                <button
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        cambiarComponenteActivo('pedidos');
                                                    }}
                                                    className={`rounded px-4 py-2 mt-2 ml-2 text-white ${componenteActivo === 'pedidos' ? 'bg-green-500' : 'bg-gray-500'
                                                        }`}
                                                >
                                                    {componenteActivo === 'pedidos' ? "Pedidos" : "Pedidos"}
                                                </button>

                                                {/* Mostrar InventarioCocina si está activo */}
                                                {componenteActivo === 'inventario' && (
                                                    <InventarioCocina cocinaId={cocina.id} nombreCocina={cocina.nombre} />
                                                )}

                                                {/* Mostrar PersonalCocina si está activo */}
                                                {componenteActivo === 'personal' && (
                                                    <PersonalCocina cocinaId={cocina.id} nombreCocina={cocina.nombre} />
                                                )}

                                                {/* Mostrar PersonalCocina si está activo */}
                                                {componenteActivo === 'pedidos' && (
                                                    <PedidosCocina cocinaId={cocina.id} nombreCocina={cocina.nombre} />
                                                )}
                                            </div>



                                        </>
                                    )}
                                </li>
                            ))}
                        </ul>



                        {!mostrarFormulario && (
                            <button
                                className="bg-blue-500 text-white px-4 py-2 rounded mb-4"
                                onClick={handleMostrarFormulario}
                            >
                                Agregar nueva cocina
                            </button>
                        )}



                        {/* Formulario para agregar una nueva cocina, visible solo cuando mostrarFormulario es true */}
                        {mostrarFormulario && (

                            <form onSubmit={handleAgregarCocina} ref={formularioRef}>

                                <h3 className="text-lg font-semibold mb-4 mt-8">Agregar nueva Cocina</h3>
                                <input
                                    type="text"
                                    value={nuevaCocina.nombre}
                                    onChange={(e) => setNuevaCocina({ ...nuevaCocina, nombre: e.target.value })}
                                    placeholder="Nombre de la cocina"
                                    className="border rounded-lg p-2 mb-2 w-full"
                                    maxLength={50}
                                />
                                <input
                                    type="text"
                                    value={nuevaCocina.ubicacion}
                                    onChange={(e) => setNuevaCocina({ ...nuevaCocina, ubicacion: e.target.value })}
                                    placeholder="Ubicación"
                                    className="border rounded-lg p-2 mb-2 w-full"
                                    maxLength={50}
                                />
                                <input
                                    type="number"
                                    value={nuevaCocina.restaurante_id}
                                    onChange={(e) => setNuevaCocina({ ...nuevaCocina, restaurante_id: e.target.value })}
                                    placeholder="Restaurante ID"
                                    className="border rounded-lg p-2 mb-2 w-full"
                                    maxLength={10}
                                />
                                <button type="submit" className="bg-green-500 px-4 py-2 rounded mb-4 text-white mr-2">
                                    Agregar
                                </button>

                                <button
                                    type="button"
                                    onClick={() => setMostrarFormulario(false)}
                                    className="bg-gray-500 text-white rounded px-4 py-2"
                                >
                                    Cancelar
                                </button>

                            </form>

                        )}



                        {mensajeExito && (
                            <p className="text-pink-500 mt-2">Cocina agregada exitosamente</p>
                        )}
                    </div>
                </div>
            </main>

            <ModalConfirm
                show={showConfirmModal}
                message={`¿Estás seguro de que quieres eliminar esta cocina?`}
                onConfirm={eliminarCocina}
                onCancel={() => setShowConfirmModal(false)}
            />
        </>
    );
};

export default Cocinas;
